module.exports = __webpack_public_path__ + "05_veryshort_gray.a7597e4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/05_veryshort_gray.png
// module id = Vo0M
// module chunks = 0